import React from 'react'
import { Icons } from '@pankod/refine-antd'
import { useRouter } from 'next/router'

import { Highlighter } from '../../utils'
import { useParticipantProfileItems } from './participant-profile-items'
import { useParticipantStatusItems } from './participant-status-items'

import type {
  TConfigurationSection,
  TConfigurationSectionContext,
} from '../types'

export const useParticipantConfiguration = (
  context: TConfigurationSectionContext,
): TConfigurationSection => {
  const router = useRouter()
  const statusItems = useParticipantStatusItems(context)
  const profileItems = useParticipantProfileItems(context)
  const { programId, runAndClose, search } = context

  return {
    menuItems: [
      {
        type: 'group',
        label: <Highlighter search={search} text="Manajemen Peserta" />,
        key: 'Manajemen Peserta',
        children: [
          {
            icon: <Icons.UserSwitchOutlined />,
            label: (
              <Highlighter
                search={search}
                text="Kelola Data Peserta (Tersier)"
              />
            ),
            key: 'Kelola Data Peserta (Tersier)',
            onClick: () =>
              runAndClose(() =>
                router.push(`/participant-management?programId=${programId}`),
              ),
          },
          ...statusItems,
          ...profileItems,
        ],
      },
    ],
  }
}
